const splashBg = {

    elements: {
        shell: null,
        hero: null
    },

    maxWidth: 1800,

    build: false,

    handleResize() 
    {
        let backgroundWidth = this.elements.hero.offsetWidth / 2;
        let backgroundPositionY = window.innerWidth * 0.19;
        
        // (Viewport width minus 767)/21.86 tells us how many 21.86s we are bigger than 767. Call this x.
        // (80-x) + ‘vw’. Or that, in proper JS.

        // below 1800, increase the Y as the browser narrows in order to center the 
        // bg on the hero image
        // and slowly decrease the size of the background image itself
        if( window.matchMedia('(max-width: 1800px) and (min-width: 1651px)').matches ) {
            let difference = this.maxWidth - window.innerWidth;
            difference += difference * 0.2;
            
            backgroundPositionY += difference;
            backgroundWidth = backgroundWidth * 0.75;
        }

        // below 1650, decrease the size of the background image more
        if( window.matchMedia('(max-width: 1650px)').matches ) {
            let difference = this.maxWidth - window.innerWidth;
            //difference += difference * 0.1;
            
            backgroundPositionY += difference;
            backgroundWidth = backgroundWidth * 0.65;
        }

        // above 1800, values become static
        if( window.matchMedia('(min-width: 1801px)').matches ) {
            backgroundWidth =   570; 
            backgroundPositionY = 330;
        }

        // don't display it at all between 767 and 2560
        if( window.matchMedia('(min-width: 2560px), (max-width: 767px)').matches ) {
            backgroundWidth = 0; 
            backgroundPositionY = -1000;
        }

        let travelDistance = 82; //82vw
        let high = 2560;
        let low = 767;
        //let bgYPosstepSize = (high - low) / travelDistance;
        let bgYPosstepSize = 21.86;
        let bgWidthStepSize = ((36 - 24) / (high - low)); 
        let bgWidthBase = 23;
        let bgYPosBase = 68;
        let yOffsetFactor = 0;

        // things go astray at 1600 so establish a small offset to add to the y value to keep it centered
        let yOffset = 0;
        if( window.innerWidth <= 1200 )
        {
            bgYPosBase = 67;
        }

        if( window.innerWidth <= 1600 )
        {
            yOffset = (1600 - window.innerWidth) * .018;
            bgWidthBase = 22;
        }
        
        if( window.innerWidth >= 2200 )
        {
            let steps = (window.innerWidth - 2200) / 440;
            yOffsetFactor = .018 + (.002 * steps);

            bgWidthBase = 22 - ((window.innerWidth - 2200) / 320);
        }

        if( yOffsetFactor > 0 )
        {
            yOffset = (window.innerWidth  - 2200) * yOffsetFactor;
        }

        // if( window.innerWidth > 3700 )
        // {
        //     bgWidthBase -= 1;
        //     yOffset += 2;
        // }

        // if( window.innerWidth > 4300 )
        // {
        //     bgWidthBase -= 1;
        //     yOffset += 1;
        // }
        
        backgroundPositionY = (bgYPosBase - ((window.innerWidth - low) / bgYPosstepSize)) + yOffset + 'vw';
        
        backgroundWidth = bgWidthBase + ((window.innerWidth - low) * bgWidthStepSize) + 'vw';

        this.elements.shell.style.setProperty('--background-size-width', backgroundWidth);
        this.elements.shell.style.setProperty('--background-position-y', backgroundPositionY);
        // this.elements.shell.style.setProperty('--background-position-y', '80vw');
    },

    cacheDom() 
    {
        const shell = document.querySelector('.shell--bg');
        const hero = document.querySelector('.hero');

        if( shell && hero )
        {
            this.elements.shell = shell;
            this.elements.hero = hero.querySelector('img');
            this.build = true;
        }
    },

    bind () 
    {
        if( this.build )
        {
            window.addEventListener('resize', e => this.handleResize() );

            this.handleResize();
        }
    },

    init() 
    {
        this.cacheDom();
        this.bind();
    }
}

export default splashBg;